import type { RestReceipt } from "@KassaroAB/shared/types/receipt";
import { API_BASE_URL } from "../constants/api";
import { apiFetchWithoutAuth, ApiError } from "../utils/api";

export interface RestPublicReceipt {
  receipt: RestReceipt;
  storeLogo: string | null;
  storeName: string;
  showArticleNumber: boolean;
  showReferenceOnReceipt: boolean;
  showStaffOnReceipt: boolean;
  showDisplayNameOnReceipt: boolean;
}

export const getPublicReceiptApi = async (
  hash: string,
): Promise<RestPublicReceipt> => {
  return apiFetchWithoutAuth(`public/receipts/${encodeURIComponent(hash)}`);
};

export const getPublicReceiptPdfApi = async (hash: string): Promise<Blob> => {
  const response = await fetch(
    `${API_BASE_URL}/public/receipts/${encodeURIComponent(hash)}/pdf`,
  );
  if (!response.ok) {
    const data = await response.json().catch(() => ({}));
    throw new ApiError(response.status, data);
  }
  return response.blob();
};

export const emailPublicReceiptApi = async (
  hash: string,
  email: string,
): Promise<void> => {
  await apiFetchWithoutAuth(`public/receipts/${encodeURIComponent(hash)}/email`, {
    method: "POST",
    body: { email },
  });
};
